import { useState } from "react";

export default function useSidebarCollapse() {
  const [collapsed, setCollapsed] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bd_nav_collapsed") || "{}"); } catch { return {}; }
  });
  const toggle = name => setCollapsed(current => {
    const next = { ...current, [name]: !current[name] };
    localStorage.setItem("bd_nav_collapsed", JSON.stringify(next));
    return next;
  });
  return { collapsed, toggle };
}
